import { useMemo } from 'react';

import type { TableColumnWidth } from './Table';

export const useTableColumnWidths = ({
    columnIds,
    getColumnWidth,
    trailingTrackWidth,
}: {
    readonly columnIds: readonly string[];
    readonly getColumnWidth: (columnId: string) => TableColumnWidth;
    readonly trailingTrackWidth?: TableColumnWidth;
}): {
    readonly gridColumnWidths: readonly TableColumnWidth[];
    readonly visibleColumnWidths: readonly TableColumnWidth[];
} => {
    const columnIdsKey = columnIds.join('\0');
    // biome-ignore lint/correctness/useExhaustiveDependencies: columnIds identity churns per render; the joined key tracks its content so the returned arrays keep referential stability.
    const visibleColumnWidths = useMemo(
        () => columnIds.map((columnId) => getColumnWidth(columnId)),
        [columnIdsKey, getColumnWidth],
    );
    const gridColumnWidths = useMemo(
        () => (trailingTrackWidth === undefined ? visibleColumnWidths : [...visibleColumnWidths, trailingTrackWidth]),
        [trailingTrackWidth, visibleColumnWidths],
    );

    return { gridColumnWidths, visibleColumnWidths };
};
